"use client";

import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import { useIntervalWhen } from "rooks";
import { type AppEvent, subscribeToAppEvents } from "../../events";
import { ConsentAcceptedEvent } from "../../events/consent-accepted.event";
import { ConsentNotShowedEvent } from "../../events/consent-not-showed.event";
import { ConsentRejectedEvent } from "../../events/consent-rejected.event";

export function SrEventListener() {
  useSrEventListener();
  return null;
}

function useSrEventListener() {
  const storedEvents = useRef<AppEvent[]>([]);
  const hasSR = useHasSR();

  const handleAppEvent = useCallback(
    (event: AppEvent) => {
      let shouldBeStored = true;

      if (
        event instanceof ConsentRejectedEvent ||
        event instanceof ConsentNotShowedEvent ||
        event instanceof ConsentAcceptedEvent
      ) {
        shouldBeStored = false;
      }

      if (!hasSR && shouldBeStored) {
        storedEvents.current.push(event);
        return;
      }
    },
    [hasSR],
  );

  useLayoutEffect(() => subscribeToAppEvents(handleAppEvent), [handleAppEvent]);

  useEffect(() => {
    if (!hasSR || storedEvents.current.length === 0) return;

    storedEvents.current.forEach(handleAppEvent);
    storedEvents.current = [];
  }, [hasSR, handleAppEvent]);
}

function useHasSR() {
  const [hasSR, setHasSR] = useState<boolean>(false);

  useIntervalWhen(
    () => {
      if (window.SR?.event) {
        setHasSR(true);
      }
    },
    1000,
    !hasSR,
  );

  return hasSR;
}
